import { Component, Vue, Prop, Provide } from 'vue-property-decorator'
import './TemedAutocomplete.scss';

export interface IAutocompleteGroup {
  title: string;
  slug: string;
  items: any[]
}


@Component({
  template: require('./TemedAutocomplete.html')
})
export class TemedAutocomplete extends Vue {
  @Prop({ default: false })
  open: boolean;

  @Prop({ default: 'Search...' })
  placeholder: string;

  @Prop()
  onSelect: (item, slug)=>{};

  @Prop()
  onSearch: (search)=>{};

  @Prop()
  onBlur: (search)=>{};

  @Prop({ default: null })
  selected: any;

  @Prop({ default: [] })
  items: IAutocompleteGroup[];

  searchString = '';

  created(){
    document.addEventListener('click', this.documentClick);
  }

  destroyed(){
    document.removeEventListener('click', this.documentClick);
  }

  search(event){
    this.onSearch(this.searchString);
  }

  select(item, slug = ''){
    if(item.zip){
      this.searchString = item.zip  || '';
    }else{
      this.searchString = item.name || '';
    }

    this.onSelect(item, slug);
  }

  documentClick(event){
    if(this.$el !== event.target && !this.$el.contains(event.target)){
      if(!this.selected){
        // this.searchString = '';
        this.onBlur(this.searchString);
      }
    }
  }
}
